const env = {
  ID: "local",
  API_URL: "https://survey.dev.api.nexlabs.app",
  AUTH_API_URL: "https://authentication.dev.api.nexlabs.app",
  GOOGLE_MAP_API_KEY: "AIzaSyDP_hYZ09oQs_8k7Ak9Y7uHjO-PDDbrWpM",
  RECAPTCHA_SITE_KEY: "6LfVS98sAAAAAFCQj_swLWv4rW09toRrV4E6YCnB",
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyBq2-YVQDyXRxYjDr-SjHX2E9uAw1m0FuI",
    authDomain: "dev-ms-auth.firebaseapp.com",
    projectId: "dev-ms-auth",
    appId: "1:855340801157:web:4fbefbfce8d0df8ff95dec",
  },
};

export default env;
